'use client';

import React from 'react';
import { ChatbotProvider } from './chatbot-provider';
import { ChatbotBubble } from './chatbot-bubble';

/**
 * Self-contained chatbot island. Rendered as a SIBLING of the page body (not
 * a wrapper) so the page content stays outside any client boundary — required
 * to keep LCP fast on tenant sites.
 *
 * The inline chatbot input block (rendered inside the page body) opens this
 * bubble via a window CustomEvent — see chatbot-open-event.ts.
 */
export const ChatbotLoader: React.FC<{
  tenantId: string;
  greeting?: string | null;
}> = ({ tenantId, greeting }) => (
  <ChatbotProvider tenantId={tenantId} greeting={greeting}>
    <ChatbotBubble />
  </ChatbotProvider>
);
